import React, { useEffect, useState } from 'react';

import { doorDashApi } from 'api/doorDash';
import { goPuffApi } from 'api/goPuff';
import { DataTable, FormComponent, Notifications } from 'shared';

function ViewWholesaleMFC({ mmFacilityOpts, stateOpts, wholesaleAccount }) {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [api, setApi] = useState(wholesaleAccount.fbmAccountName === 'doordash' ? doorDashApi : goPuffApi);

    // Load  table
    const getRows = async () => {
        const response = await api.getMicroFulfillmentCenters();
        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data.rows);
    };

    useEffect(() => {
        if (wholesaleAccount.fbmAccountName === 'doordash') {
            setApi(doorDashApi);
        } else {
            setApi(goPuffApi);
        }
    }, [wholesaleAccount]);

    useEffect(() => {
        if (api) {
            getRows();
        }
    }, [api]);

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'name', Header: 'Name', editable: true },
        { accessor: 'lineOne', Header: 'Line One', editable: true },
        { accessor: 'lineTwo', Header: 'Line Two', editable: true },
        { accessor: 'city', Header: 'City', editable: true },
        {
            accessor: 'state',
            Header: 'State',
            type: 'select',
            editable: true,
            editProps: { type: 'select', options: stateOpts },
        },
        { accessor: 'zip', Header: 'Zip', editable: true },
        { accessor: 'phone', Header: 'Phone', editable: true },
        {
            accessor: 'active',
            Header: 'Active',
            type: 'checkbox',
            editable: true,
            editProps: { type: 'checkbox' },
        },
        {
            accessor: 'mmFacilityId',
            Header: 'MM Facility',
            type: 'select',
            editable: true,
            editProps: { type: 'select', options: mmFacilityOpts },
        },
    ];

    return (
        <div>
            <h1>{wholesaleAccount.companyName} Micro Fulfillment Centers</h1>
            <Notifications options={notification} />
            {}
            <div>
                <DataTable
                    columns={columns}
                    data={rows}
                    editable
                    saveEdit={async ({ field, id, row, value }) => {
                        const item = {};
                        item[field] = value;
                        const response = await api.updateMicroFulfillmentCenter(id, item);

                        if (response.status === false) {
                            setNotification({ text: `Failed: ${response.msg}`, level: 'error' });
                            return;
                        }

                        setNotification({ text: 'Success!', level: 'success' });
                        getRows();
                    }}
                />
            </div>
        </div>
    );
}

export { ViewWholesaleMFC };
